/* eslint-env browser */
import container from 'modules/section-content';
import domify from 'domify';
import page from 'modules/ab-page-js';
import signupForm from 'modules/signupForm';
import metadata from './data/metadata.json';
import layout from './views/signup.pug';

export default function register() {
  page('/signup', render);
}

function render(ctx, next) {
  const { AUTH0_CLIENT_ID, AUTH0_DOMAIN, AUTH0_CALLBACK_URL } = window.APP_CONFIG;
  const { AUTH0_CONNECTION } = window.APP_CONFIG_SIGNUP;

  const renderOptions = {
    signupFormApp: signupForm({
      clientID: AUTH0_CLIENT_ID,
      domain: AUTH0_DOMAIN,
      callbackURL: AUTH0_CALLBACK_URL,
      dbConnectionName: AUTH0_CONNECTION
    }),
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(layout()) })
  };
  container.render(renderOptions);

  return next();
}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.js